"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ajaxRequest;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("axios"));
var _timeoutPromise = _interopRequireDefault(require("Functions/ajax/timeoutPromise"));
var _getTimeout = _interopRequireDefault(require("Functions/ajax/getTimeout"));
var _getErrors = _interopRequireDefault(require("Functions/ajax/getErrors"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const DEFAULT_ERR = 'Connexion impossible pour le moment, ' + 'veuillez vérifier votre connexion ou réessayez ultérieurement.';
async function ajaxRequest(url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    min_duration = 440
  } = options;
  let req_time = new Date();
  const headers = {};
  if (options.files === true) {
    headers['Content-Type'] = 'multipart/form-data';
  }
  let completed = false;
  try {
    const cancel_token = options.axios_token || _axios.default.CancelToken.source();
    (0, _timeoutPromise.default)(options.files ? 60 * 15 * 1000 : options.timeout).then(function () {
      if (completed === false) cancel_token.cancel();
    });
    const config = {
      headers: headers,
      cancelToken: cancel_token.token
    };
    if (options.axios_params) Object.assign(config, options.axios_params);
    const {
      data: response
    } = await _axios.default.post(url, options.data, config);
    completed = true;
    return new Promise(function (resolve) {
      setTimeout(() => resolve(response), (0, _getTimeout.default)(req_time, min_duration));
    });
  } catch (e) {
    var _e$response, _e$response2, _e$response3, _e$response3$data;
    completed = true;
    if (!((_e$response = e.response) !== null && _e$response !== void 0 && _e$response.data)) console.error('!e.response?.data', e);
    const update = _objectSpread({}, (0, _getErrors.default)({
      response: (_e$response2 = e.response) !== null && _e$response2 !== void 0 && _e$response2.data ? e.response.data : undefined,
      error: ((_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : _e$response3$data.error) || DEFAULT_ERR
    }));
    throw update;
  }
}
